import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import i18n from "@/i18n";
import ar from "@/locales/ar.json";
import Logo from "@/components/Logo";
import { ArrowLeft, CheckCircle2 } from "lucide-react";

// Thank you page is ALWAYS in Spanish, at /thank_you
export default function ThankYou() {
  useEffect(() => {
    // Force Spanish rendering on this page
    if (i18n.language !== "ar") {
      i18n.changeLanguage("ar");
    }
    document.documentElement.lang = "es-AR";
    document.title = "¡Gracias! — Zantravora";
  }, []);

  const ty = ar.thank_you;

  return (
    <main id="main" className="min-h-screen bg-[#0d1117] text-[#f6f0e2] flex flex-col">
      <div className="zv-container pt-10 flex items-center justify-between">
        <Link to="/" aria-label="Zantravora"><Logo variant="light" /></Link>
      </div>
      <div className="zv-container flex-1 flex items-center py-24">
        <div className="max-w-[720px] w-full">
          <div className="inline-flex items-center gap-2 border border-[#c8622a]/60 text-[#c8622a] rounded-full px-4 py-1 text-[12px] tracking-widest uppercase mb-8">
            <CheckCircle2 size={14} /> {ty.eyebrow}
          </div>
          <h1 className="zv-serif text-6xl md:text-8xl leading-[0.95] mb-8">{ty.title}</h1>
          <p className="text-[18px] leading-relaxed text-white/80 max-w-xl">{ty.lead}</p>
          <p className="mt-6 text-[15px] text-white/60 max-w-xl">{ty.note}</p>
          <div className="mt-12">
            <Link to="/" className="zv-btn zv-btn-cream">
              <ArrowLeft size={16} /> {ty.back}
            </Link>
          </div>
        </div>
      </div>
      <div className="zv-container pb-8 text-[12px] text-white/40">
        © 2026 Zantravora Inversiones Colaborativas S.A.S.
      </div>
    </main>
  );
}
